import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import removeAttendees from 'owa-calendar-compose-form-actions/lib/actions/removeAttendees';
import { orchestrator } from 'satcheljs';
import {
    updateRequiredAttendees,
    updateOptionalAttendees,
} from 'owa-calendar-compose-form-actions';

/**
 * Subscribe to action removeAttendees to remove the removed email addresses from the event in calendar-compose-form-store
 */
export default orchestrator(removeAttendees, actionMessage => {
    const { formId, emailAddresses } = actionMessage;
    const event = getComposeEvent(formId);

    if (!event) {
        return;
    }
    const removedEmailAddresses = emailAddresses.map(emailAddress => emailAddress.EmailAddress);
    const existingRequiredAttendees = event.RequiredAttendees;
    const existingOptionalAttendees = event.OptionalAttendees;
    const doesAttendeePersist = attendee =>
        !removedEmailAddresses.includes(attendee.Mailbox.EmailAddress);
    existingRequiredAttendees &&
        updateRequiredAttendees(existingRequiredAttendees.filter(doesAttendeePersist), formId);
    existingOptionalAttendees &&
        updateOptionalAttendees(existingOptionalAttendees.filter(doesAttendeePersist), formId);
});
